import React from "react";
import FormModal from "../../../../Modals/FormModal";
import TransferInfoSection from "../TransferDetail/Sections/TransferInfoSection";
import TransferBranchesSection from "../TransferDetail/Sections/TransferBranchesSection";
import TransferFlowSection from "../TransferDetail/Sections/TransferFlowSection";
import AuditSection from "../TransferDetail/Sections/AuditSection";
import { useInventoryTransfer } from "../../../../../hooks/inventory/useInventoryTransfer";

const InventoryTransferApproveModal: React.FC = () => {

  const { handlerApprove, showApproveModal, form, closeApproveModal } =
    useInventoryTransfer();

  if (!form) return null;

  const canApprove =
    form.status === "REQUESTED" || form.status === "APROVADO";

  return (
    <FormModal
      isOpen={showApproveModal}
      onClose={closeApproveModal}
      title="Aprobar Traslado"
      maxWidth="max-w-4xl"
      zIndex='front'
    >
      <div className="space-y-8 px-2 py-4">
        <TransferInfoSection
          details={form.details}
          reason={form.reason}
          status={form.status}
        />

        <TransferBranchesSection
          origin={form.originBranchName}
          destination={form.destinationBranchName}
        />

        <TransferFlowSection detail={form} />

        <AuditSection detail={form} />
      </div>

      {/* -------------------------------------------------------- */}
      {/* BOTONES DE ACCIÓN */}
      {/* -------------------------------------------------------- */}
      <div className="mt-6 flex justify-end gap-3">

        {/* CERRAR */}
        <button
          type="button"
          onClick={closeApproveModal}
          className="inline-flex rounded bg-[#637381] px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
        >
          Cerrar
        </button>

        {/* APROBAR */}
        {canApprove && (
          <button
            type="button"
            onClick={() => handlerApprove(form.id)}
            className="inline-flex rounded bg-primary px-6 py-2 text-sm font-medium text-white hover:bg-opacity-90"
          >
            Aprobar
          </button>
        )}
      </div>
    </FormModal>
  );
};

export default InventoryTransferApproveModal;
